import { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  TextField,
  Button,
  Typography,
  createTheme,
  Box,
  Link,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { palette } from '@mui/system';
import { useFetch } from '../../hooks/useFetch';
import CircularProgress from '@mui/material/CircularProgress';
import SelectNationality from '../SelectNationality';
import { NatOutlined } from '@mui/icons-material';
import validator from 'validator';
import SelectTitle from '../SelectTitle';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import SelectRace from '../SelectRace';
import SelectSALang from '../SelectSALang';
import SelectRelationship from '../SelectRelationship';
import EnterEmail from '../EnterEmail';
import EnterIDPass from '../EnterIDPass';
function AddNewParent({ studentId, handleParentLinked }) {
  const [ipAddress, setIPAddress] = useState('');

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then((data) => setIPAddress(data.ip))
      .then(console.log('My ip address is ' + ipAddress))
      .catch((error) => console.log(error));
  }, [ipAddress]);

  const {
    postData: checkParentbyID,
    error,
    errorMessage,
    data: parentCheck,
    isPending,
  } = useFetch(
    'https://pcapi.bi-oss.co.za/parent/checkforexisting/byid',
    'POST',
  );
  const {
    postData: confirmExistingEmail,
    error: error2,
    errorMessage: errorMessage2,
    data: existingEmailConfirmed,
    isPending: isPending2,
  } = useFetch(
    'https://pcapi.bi-oss.co.za/parent/existing/verifyemailandsendotp',
    'POST',
  );
  const {
    postData: confirmExistingOTP,
    error: error3,
    errorMessage: errorMessage3,
    data: existingOTPConfirmed,
    isPending: isPending3,
  } = useFetch('https://pcapi.bi-oss.co.za/parent/existing/verifyotp', 'POST');

  const {
    postData: checkNewEmail,
    error: error5,
    errorMessage: errorMessage5,
    data: newEmailVerified,
    isPending: isPending5,
  } = useFetch(
    'https://pcapi.bi-oss.co.za/parent/newparent/checkemail',
    'POST',
  );
  const {
    postData: verifyNewOTP,
    error: error6,
    errorMessage: errorMessage6,
    data: newOTPVerified,
    isPending: isPending6,
  } = useFetch('https://pcapi.bi-oss.co.za/parent/newparent/verifyOTP', 'POST');

  const [email, setEmail] = useState('');
  const [pid, setPid] = useState('');
  const [succ, setSucc] = useState('');

  const [createNew, setCreateNew] = useState(0);
  const [existingParent, setExistingParent] = useState(0);

  const [otp, setOTP] = useState('');
  const [otpSent, setOTPSent] = useState(0);

  const [idpass, setIdPass] = useState('');

  const [nation, setNation] = useState('South African');
  const [resend, setResend] = useState(0);

  const [title, setTitle] = useState('');
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [dob, setDob] = useState('');
  const [gender, setGender] = useState('');
  const [raceId, setRaceId] = useState('');
  const [saMobile, setSaMobile] = useState('');
  const [intMobile, setIntMobile] = useState('');
  const [workTel, setWorkTel] = useState('');
  const [homeTel, setHomeTel] = useState('');
  const [languageId, setLanguageId] = useState('');
  const [address, setAddress] = useState('');

  const [partialEmail, setPartialEmail] = useState('');
  const [relationship, setRelationship] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    checkParentbyID({
      idpass,
    });
  };

  useEffect(() => {
    if (parentCheck) {
      if (parentCheck.parentCount === 0) {
        setCreateNew(1);
        setExistingParent(0);
      }
      if (parentCheck.parentCount > 0) {
        setCreateNew(0);
        setExistingParent(1);
        setPartialEmail(parentCheck.partialEmail);
      }
    }
  }, [parentCheck]);
  const handleSubmit2 = (e) => {
    e.preventDefault();
    confirmExistingEmail({ idpass, email, studentId });
  };

  useEffect(() => {
    if (existingEmailConfirmed) {
      setOTPSent(1);
    }
  }, [existingEmailConfirmed]);
  const handleSubmit3 = (e) => {
    e.preventDefault();
    confirmExistingOTP({
      idpass,
      otp,
      studentId,
      relationship,
      email,
      ipAddress,
    });
  };

  const resendOTP = (e) => {
    setResend(1);
    confirmExistingEmail({ idpass, email, studentId, relationship });
  };

  useEffect(() => {
    if (existingOTPConfirmed) {
      setSucc(1);
    }
  }, [existingOTPConfirmed]);

  const handleSubmit4 = (e) => {
    handleParentLinked();
  };

  const handleSubmit5 = (e) => {
    e.preventDefault();

    checkNewEmail({
      email,
      title,
      fname,
      lname,
      studentId,
      dob,
    });
  };

  useEffect(() => {
    if (newEmailVerified) {
      setOTPSent(1);
    }
  }, [newEmailVerified]);

  const handleSubmit6 = (e) => {
    e.preventDefault();
    verifyNewOTP({
      studentId,
      dob,
      title,
      fname,
      lname,
      gender,
      raceId,
      email,
      saMobile,
      workTel,
      homeTel,
      languageId,
      relationship,
      address,
      otp,
      nation,
      idpass,
      ipAddress,
    });
  };

  const resendOTP2 = (e) => {
    setResend(1);
    checkNewEmail({
      email,
      title,
      fname,
      lname,
      studentId,
      dob,
    });
  };

  useEffect(() => {
    if (newOTPVerified) {
      setSucc(1);
    }
  }, [newOTPVerified]);

  return (
    <>
      {isPending5 && (
        <>
          <Container maxWidth="md">
            <Box mb={5} />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'primary.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography
                    variant="body2"
                    component="p"
                    color="primary.main"
                    sx={{ textAlign: 'center' }}
                  >
                    Checking parent email...
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <CircularProgress />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
      {isPending && (
        <>
          <Container maxWidth="md">
            <Box mb={5} />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'primary.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography
                    variant="body2"
                    component="p"
                    color="primary.main"
                    sx={{ textAlign: 'center' }}
                  >
                    Reviewing parent identification...
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <CircularProgress />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
      {!existingParent && !createNew && !succ && !isPending && (
        <>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box mb={5} />
            <Container
              maxWidth="md"
              disableGutters
              align="center"
              top="50%"
              sx={{
                backgroundColor: 'white',
                opacity: '1',
                border: 'Solid',
                borderWidth: '5px',
                borderColor: 'primary.main',
                padding: '30px',
                borderRadius: 3,
                marginTop: 3,
              }}
            >
              <form onSubmit={handleSubmit}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                >
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="h3"
                        color="textSecondary"
                        component="h2"
                        gutterBottom
                      >
                        Add Parent or Guardian
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="paragraph"
                        color="textSecondary"
                        component="p"
                        gutterBottom
                        fontFamily={'Arial'}
                      >
                        Candidates under the age of 18 must link one of their
                        legal parents or guardians before processing an
                        examination entry. The parent or guardians will need to
                        accept the terms and conditions prior to being linked to
                        the candidate’s profile.
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      textAlign="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="textSecondary"
                        component="h6"
                        fontFamily={'Arial'}
                      >
                        <b>Please note the following:</b>
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      textAlign="left"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Typography
                        variant="paragraph"
                        color="textSecondary"
                        component="p"
                        fontFamily={'Arial'}
                      >
                        <ul>
                          <li>
                            South African Citizens must use their RSA
                            Identification Number.
                          </li>
                          <li>
                            International parents or Guardian's may use their
                            international passport number; however, the
                            candidate will be required to prove eligibility to
                            study within South Africa prior to writing
                            examinations.
                          </li>
                          <li>
                            A copy of both the candidate and parent or
                            guardian’s identification will be required prior to
                            entry.{' '}
                          </li>

                          <li>
                            Examination entries or results will be forfeit{' '}
                            <b>without a refund</b> if falsified information is
                            supplied. This will be at the discretion of British
                            International Colleges and Schools.
                          </li>
                        </ul>
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="h5"
                        color="textSecondary"
                        component="h5"
                        gutterBottom
                        fontFamily={'Arial'}
                      >
                        Enter Parent or Guardian Details
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <SelectNationality
                        nation={nation}
                        setNation={setNation}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <EnterIDPass
                        nation={nation}
                        setIdPass={setIdPass}
                        idpass={idpass}
                      />
                    </Box>
                  </Grid>
                  {isPending && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Button variant="contained" disabled fullWidth>
                              <CircularProgress />
                            </Button>
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>
                  )}
                  {!isPending && (
                    <>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <Button
                                variant="contained"
                                type="submit"
                                fullWidth
                              >
                                Continue
                              </Button>
                            </Box>
                          </Grid>
                        </Box>
                        <Box mb={5} />
                      </Grid>

                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <Button
                                fullWidth
                                variant="contained"
                                onClick={(e) => window.location.reload()}
                              >
                                Dashboard
                              </Button>
                            </Box>
                          </Grid>
                        </Box>
                      </Grid>
                    </>
                  )}
                </Grid>
              </form>
            </Container>
          </Box>
        </>
      )}

      {existingParent > 0 && !succ && (
        <>
          {!otpSent && (
            <Container
              maxWidth="md"
              disableGutters
              align="center"
              top="50%"
              sx={{
                backgroundColor: 'white',
                opacity: '1',
                border: 'Solid',
                borderWidth: '5px',
                borderColor: 'primary.main',
                padding: '30px',
                borderRadius: 3,
                marginTop: 3,
              }}
            >
              <form onSubmit={handleSubmit2}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                >
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="h4"
                        color="textSecondary"
                        component="h4"
                        gutterBottom
                      >
                        Existing Parent or Guardian
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="h5"
                        color="textSecondary"
                        component="h5"
                        gutterBottom
                      >
                        Verification Step 1/2:
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="paragraph"
                        color="textSecondary"
                        component="p"
                        gutterBottom
                        fontFamily={'Arial'}
                      >
                        A parent or guardian profile matching this
                        identification information has been found. To verify
                        their account, please enter thier full email address
                        matching the below partial email below.
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="paragraph"
                        color="textSecondary"
                        component="p"
                        gutterBottom
                        fontFamily={'Arial'}
                      >
                        <b>Partial Email: </b> {partialEmail}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      f
                      alignItems="center"
                      textAlign="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <TextField
                            id="emailbox"
                            label="Email Address:"
                            variant="outlined"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                            autoComplete="email"
                            autoFocus
                            inputProps={{ style: { textAlign: 'center' } }}
                          />
                        </Box>
                      </Grid>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="paragraph"
                        color="textSecondary"
                        component="p"
                        gutterBottom
                        fontFamily={'Arial'}
                      >
                        Please confirm the parent of guardian’s relationship
                        with the candidate.
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      f
                      alignItems="center"
                      textAlign="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <SelectRelationship
                            relationship={relationship}
                            setRelationship={setRelationship}
                          />
                        </Box>
                      </Grid>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      f
                      alignItems="center"
                      textAlign="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      {error2 && !errorMessage2 && (
                        <p className="error">
                          Service currently offline. Please try again later.
                        </p>
                      )}
                      {errorMessage2 && (
                        <p className="error">{errorMessage2}</p>
                      )}
                    </Box>
                  </Grid>

                  {isPending2 && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Button variant="contained" disabled fullWidth>
                              <CircularProgress />
                            </Button>
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>
                  )}
                  {!isPending2 && (
                    <>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          f
                          alignItems="center"
                          textAlign="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button
                                variant="contained"
                                type="submit"
                                fullWidth
                              >
                                Confirm
                              </Button>
                            </Box>
                          </Grid>
                        </Box>

                        <Box mb={5} />
                      </Grid>

                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          f
                          alignItems="center"
                          textAlign="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button
                                fullWidth
                                variant="contained"
                                onClick={(e) => window.location.reload()}
                              >
                                Dashboard
                              </Button>
                            </Box>
                          </Grid>
                        </Box>
                      </Grid>
                    </>
                  )}
                </Grid>
              </form>
            </Container>
          )}

          {otpSent > 0 && (
            <Container
              maxWidth="md"
              disableGutters
              align="center"
              top="50%"
              sx={{
                overflow: 'scroll',
                maxHeight: '90vh',
                backgroundColor: 'white',
                opacity: '1',
                border: 'Solid',
                borderWidth: '5px',
                borderColor: 'primary.main',
                padding: '30px',
                borderRadius: 3,
                marginTop: 3,
              }}
            >
              <form onSubmit={handleSubmit3}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                >
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Typography
                        variant="h4"
                        color="textSecondary"
                        component="h4"
                        gutterBottom
                      >
                        Existing Parent Profile
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Typography
                        variant="h5"
                        color="textSecondary"
                        component="h5"
                        gutterBottom
                      >
                        Verification Step 2/2:
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Typography
                        variant="paragraph"
                        color="textSecondary"
                        component="p"
                        gutterBottom
                        fontFamily={'Arial'}
                      >
                        A one time pin (OTP) has been sent to the parent email
                        address: {email}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Typography
                        variant="paragraph"
                        color="textSecondary"
                        component="p"
                        gutterBottom
                        fontFamily={'Arial'}
                      >
                        Please enter the OTP below.
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <TextField
                            id="otp"
                            label="Enter OTP:"
                            variant="outlined"
                            type="numbers"
                            required
                            onChange={(e) => setOTP(e.target.value)}
                            value={otp}
                            fullWidth
                            autoFocus
                            inputProps={{ style: { textAlign: 'center' } }}
                          />
                        </Box>
                      </Grid>
                    </Box>
                  </Grid>

                  {error3 && !errorMessage3 && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <p className="error">
                          Service currently offline. Please try again later.
                        </p>
                      </Box>
                    </Grid>
                  )}
                  {errorMessage3 && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <p className="error">{errorMessage3}</p>
                      </Box>
                    </Grid>
                  )}

                  {!isPending3 && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Button variant="contained" type="submit" fullWidth>
                              Submit OTP
                            </Button>
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>
                  )}

                  {isPending3 && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Button variant="contained" disabled fullWidth>
                              <CircularProgress />
                            </Button>
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>
                  )}

                  {!resend && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Typography
                          variant="paragraph"
                          color="textSecondary"
                          component="p"
                          gutterBottom
                          fontFamily={'Arial'}
                        >
                          OR
                        </Typography>
                      </Box>
                    </Grid>
                  )}

                  {!isPending3 && !resend && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Button
                              variant="contained"
                              onClick={(e) => resendOTP()}
                              fullWidth
                            >
                              Resend OTP
                            </Button>
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>
                  )}
                  {resend === 1 && !isPending3 && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Typography
                          variant="paragraph"
                          color="textSecondary"
                          component="p"
                          gutterBottom
                          fontFamily={'Arial'}
                        >
                          OTP resent via email to {partialEmail}
                        </Typography>
                      </Box>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Box mb={5} />
                    </Box>
                  </Grid>
                  <Box mb={5} />
                  {!isPending3 && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        f
                        alignItems="center"
                        textAlign="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              onClick={(e) => window.location.reload()}
                            >
                              Dashboard
                            </Button>
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </form>
            </Container>
          )}
        </>
      )}

      {succ === 1 && (
        <>
          <Container
            maxWidth="md"
            disableGutters
            align="center"
            top="50%"
            sx={{
              backgroundColor: 'white',
              opacity: '1',
              border: 'Solid',
              borderWidth: '5px',
              borderColor: 'success.main',
              padding: '30px',
              borderRadius: 3,
              marginTop: 3,
            }}
          >
            <form onSubmit={handleSubmit4}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              >
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography
                      variant="h4"
                      color="success.main"
                      component="h4"
                      gutterBottom
                    >
                      Parent or Guardian Linked
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    f
                    alignItems="center"
                    textAlign="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Button
                          color="success"
                          variant="contained"
                          onClick={(e) => handleParentLinked()}
                          fullWidth
                        >
                          Close
                        </Button>
                      </Box>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </Container>
        </>
      )}

      {createNew === 1 && !isPending5 && !otpSent && !succ && (
        <>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box mb={5} />
            <Container
              maxWidth="md"
              disableGutters
              align="center"
              top="50%"
              sx={{
                backgroundColor: 'white',
                opacity: '1',
                border: 'Solid',
                borderWidth: '5px',
                borderColor: 'primary.main',
                padding: '30px',
                borderRadius: 3,
                marginTop: 3,
              }}
            >
              <form onSubmit={handleSubmit5}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                >
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="h3"
                        color="textSecondary"
                        component="h2"
                        gutterBottom
                      >
                        Additional Details
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="h5"
                        color="textSecondary"
                        component="h5"
                        gutterBottom
                        fontFamily={'Arial'}
                      >
                        Enter Parent or Guardian Details
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <SelectNationality
                        nation={nation}
                        setNation={setNation}
                        disabled={1}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <TextField
                        id="idpass"
                        label="RSA Identification or International Passport Number"
                        onChange={(e) => setIdPass(e.target.value)}
                        content="center"
                        value={idpass}
                        fullWidth
                        required
                        inputProps={{
                          minLength: 13,
                          maxLength: 13,
                          pattern: '[0-9]+',
                          style: { textAlign: 'center' },
                        }}
                        autoComplete="nope"
                        disabled
                      />
                    </Box>
                  </Grid>
                  {!errorMessage5 && !isPending5 && (
                    <>
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              label="Parent DOB (YYYY/MM/DD)"
                              inputFormat="yyyy/MM/dd"
                              value={dob}
                              onChange={(value) => setDob(value)}
                              renderInput={(params) => (
                                <TextField {...params} fullWidth />
                              )}
                            />
                          </LocalizationProvider>
                        </Box>
                      </Grid>

                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <SelectTitle title={title} setTitle={setTitle} />
                        </Box>
                      </Grid>

                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <TextField
                            id="fname"
                            label="Parent First Names"
                            value={fname}
                            fullWidth
                            required
                            onChange={(e) => setFname(e.target.value)}
                            autoComplete="nope"
                            inputProps={{
                              maxLength: 100,
                              minLength: 3,
                              style: { textTransform: 'capitalize' },
                            }}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <TextField
                            id="lname"
                            label="Parent Last Name"
                            value={lname}
                            fullWidth
                            required
                            onChange={(e) => setLname(e.target.value)}
                            autoComplete="nope"
                            inputProps={{
                              maxLength: 100,
                              minLength: 3,
                              style: { textTransform: 'capitalize' },
                            }}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <FormControl fullWidth>
                            <InputLabel id="genderL">Gender*</InputLabel>

                            <Select
                              labelId="genderL"
                              id="Gender"
                              value={gender}
                              onChange={(e) => setGender(e.target.value)}
                              input={<OutlinedInput label="genderL" />}
                              required
                            >
                              <MenuItem value="M">Male</MenuItem>
                              <MenuItem value="F">Female</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <SelectRace setRaceId={setRaceId} raceId={raceId} />
                        </Box>
                      </Grid>
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <EnterEmail email={email} setEmail={setEmail} />
                        </Box>
                      </Grid>

                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <TextField
                            id="saMobile"
                            label="Parent SA Mobile/Comms"
                            onChange={(e) => setSaMobile(e.target.value)}
                            value={saMobile}
                            fullWidth
                            type="tel"
                            inputProps={{ maxLength: 10, minLength: 10 }}
                            autoComplete="nope"
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <TextField
                            id="workTel"
                            label="Work Tel"
                            value={workTel}
                            fullWidth
                            type="tel"
                            inputProps={{ maxLength: 15, minLength: 10 }}
                            onChange={(e) => setWorkTel(e.target.value)}
                            required
                            autoComplete="nope"
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <TextField
                            id="homeTel"
                            label="Home Tel"
                            value={homeTel}
                            fullWidth
                            type="tel"
                            inputProps={{ maxLength: 15, minLength: 10 }}
                            onChange={(e) => setHomeTel(e.target.value)}
                            autoComplete="nope"
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <SelectSALang
                            languageId={languageId}
                            setLanguageId={setLanguageId}
                            label="Home Language"
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <SelectRelationship
                            relationship={relationship}
                            setRelationship={setRelationship}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <TextField
                            id="postal"
                            label="Postal Address"
                            value={address}
                            fullWidth
                            required
                            onChange={(e) => setAddress(e.target.value)}
                            autoComplete="nope"
                            inputProps={{
                              maxLength: 200,
                              minLength: 3,
                              style: { textTransform: 'capitalize' },
                            }}
                          />
                        </Box>
                      </Grid>
                    </>
                  )}

                  {errorMessage5 && (
                    <>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          f
                          alignItems="center"
                          textAlign="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <p className="error">{errorMessage5}</p>
                        </Box>
                      </Grid>

                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <EnterEmail email={email} setEmail={setEmail} />
                            </Box>
                          </Grid>
                        </Box>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Button variant="contained" type="submit" fullWidth>
                            Continue
                          </Button>
                        </Box>
                      </Grid>
                    </Box>
                    <Box mb={5} />
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Button
                            fullWidth
                            variant="contained"
                            onClick={(e) => window.location.reload()}
                          >
                            Dashboard
                          </Button>
                        </Box>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </Container>
          </Box>
        </>
      )}

      {createNew === 1 && !isPending5 && otpSent && !succ && (
        <>
          <Container
            maxWidth="md"
            disableGutters
            align="center"
            top="50%"
            sx={{
              overflow: 'scroll',
              maxHeight: '90vh',
              backgroundColor: 'white',
              opacity: '1',
              border: 'Solid',
              borderWidth: '5px',
              borderColor: 'primary.main',
              padding: '30px',
              borderRadius: 3,
              marginTop: 3,
            }}
          >
            <form onSubmit={handleSubmit6}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              >
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Typography
                      variant="h4"
                      color="textSecondary"
                      component="h4"
                      gutterBottom
                    >
                      Parent Profile
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Typography
                      variant="h5"
                      color="textSecondary"
                      component="h5"
                      gutterBottom
                    >
                      Verification Step:
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Typography
                      variant="paragraph"
                      color="textSecondary"
                      component="p"
                      gutterBottom
                      fontFamily={'Arial'}
                    >
                      A one time pin (OTP) has been sent to the parent email
                      address: {email}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Typography
                      variant="paragraph"
                      color="textSecondary"
                      component="p"
                      gutterBottom
                      fontFamily={'Arial'}
                    >
                      Please enter the OTP below.
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <TextField
                          id="otp"
                          label="Enter OTP:"
                          variant="outlined"
                          type="numbers"
                          required
                          onChange={(e) => setOTP(e.target.value)}
                          value={otp}
                          fullWidth
                          autoFocus
                          inputProps={{ style: { textAlign: 'center' } }}
                        />
                      </Box>
                    </Grid>
                  </Box>
                </Grid>

                {error6 && !errorMessage6 && (
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <p className="error">
                        Service currently offline. Please try again later.
                      </p>
                    </Box>
                  </Grid>
                )}
                {errorMessage6 && (
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <p className="error">{errorMessage6}</p>
                    </Box>
                  </Grid>
                )}

                {!isPending6 && (
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Button variant="contained" type="submit" fullWidth>
                            Submit OTP
                          </Button>
                        </Box>
                      </Grid>
                    </Box>
                  </Grid>
                )}

                {isPending6 && (
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Button variant="contained" disabled fullWidth>
                            <CircularProgress />
                          </Button>
                        </Box>
                      </Grid>
                    </Box>
                  </Grid>
                )}

                {!resend && !isPending6 && (
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Typography
                        variant="paragraph"
                        color="textSecondary"
                        component="p"
                        gutterBottom
                        fontFamily={'Arial'}
                      >
                        OR
                      </Typography>
                    </Box>
                  </Grid>
                )}

                {!isPending6 && !resend && (
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={(e) => resendOTP2()}
                            fullWidth
                          >
                            Resend OTP
                          </Button>
                        </Box>
                      </Grid>
                    </Box>
                  </Grid>
                )}
                {resend === 1 && (
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Typography
                        variant="paragraph"
                        color="textSecondary"
                        component="p"
                        gutterBottom
                        fontFamily={'Arial'}
                      >
                        OTP resent via email to {email}
                      </Typography>
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Box mb={5} />
                  </Box>
                </Grid>
                <Box mb={5} />
                {isPending6 && (
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      f
                      alignItems="center"
                      textAlign="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Button
                            fullWidth
                            variant="contained"
                            onClick={(e) => window.location.reload()}
                          >
                            Dashboard
                          </Button>
                        </Box>
                      </Grid>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </form>
          </Container>
        </>
      )}
    </>
  );
}

export default AddNewParent;
